import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaSpinner, FaFileInvoice, FaExpandArrowsAlt, FaCreditCard, FaCertificate, FaTimes } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import './Pending.css';

// ══════════════════════════════════════
//  CONSTANTS
// ══════════════════════════════════════
const API = 'https://digitalapi.definiteassurance.com/api';
const COMPANY = 'Definite';
const ROWS_PER_PAGE = 20;
const CERT_WEBHOOK = 'https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0';
const PAYMENT_WEBHOOK = 'https://workflows.uuidesign.xyz/webhook/0623c8f7-d286-45c4-b823-2675d25de35a';
const WALLET_WEBHOOK = 'https://sms.definiteassurance.com/webhook/04a58cac-a6b4-4bde-883a-b364f32d9ae9';

// ══════════════════════════════════════
//  HELPERS
// ══════════════════════════════════════
const formatter = (amount) =>
  Number(amount || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

const formatISODate = (input) => {
  try {
    if (typeof input === 'string') return input.split('T')[0];
    if (input instanceof Date) return input.toISOString().split('T')[0];
    return '--';
  } catch { return '--'; }
};

const buildPageNumbers = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
};

const generateUniqueId = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};

const getNow = () => {
  const d = new Date();
  const pad = (n, len = 2) => String(n).padStart(len, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(), 3)}`;
};

// ══════════════════════════════════════
//  COMPONENT
// ══════════════════════════════════════
export default function Pending() {
  const navigate = useNavigate();

  // ── Auth & agent ──
  const [credentials, setCredentials] = useState(null);
  const [isAuth, setIsAuth] = useState(false);
  const [agent, setAgent] = useState('');
  const [agentCode, setAgentCode] = useState('');
  const [agentName, setAgentName] = useState('');
  const [parentIntermediary, setParentIntermediary] = useState('');

  // ── Data ──
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  //Proposal details modal
    const [selectedProposal, setSelectedProposal] = useState(null);
    const [clientName, setClientName] = useState('');
    const [clientEmail, setClientEmail] = useState('');
    const [clientPhone, setClientPhone] = useState('');
    const [clientPin, setClientPin] = useState(''); 
    const [insuredOID, setInsuredOID] = useState('');
    const [bodyType, setBodytype] = useState('');
    const [coption, setCoverOption] = useState('');
    const [make, setMake] = useState('');
    const [model, setModel] = useState('');
    const [capacity, setCapacity] = useState('');
    const [chasis, setChassis] = useState('');
    const [year, setYear] = useState('');
    const [sumInsured, setSumInsured] = useState('');
    const [engineNo, setEngineNo] = useState('');
    const [cc, setCC] = useState('');
    const [tonnage, setTonnage] = useState('');
    const [itemName, setItemName] = useState('');
    const [product, setProduct] = useState('');
    const [prdCode, setPrdCode] = useState('');
    const [riskClass,setRiskClass] = useState('')
    const [commencementDate, setCommencementDate] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [grossPremium, setGrossPremium] = useState('');
    const [dateDone, setDateDone] = useState('');
    const [narration, setNarration] = useState('');
    const [periodOfCover, setPeriodOfCover] = useState('');
    const [policyNo, setPolicyNo] = useState('');
    const [grossCommission, setGrossCommission] = useState('');
    const [phcf, setPHCF] = useState('');
    const [trainingLevy, setTrainingLevy] = useState('');
    const [paidAmount, setPaidAmount] = useState('');
    const [today] = useState(getNow());
    const [selectedClient,setSelectedclient] = useState(null)
    const [netPremium, setNetpremium] = useState(null)
    const [netCommission, setNetcommission] = useState(null)
    const [stampDuty, setStampduty] = useState(null)
  // ── Payment modal state ──
  const [showPayModal, setShowPayModal] = useState(false);
  const [paymentMode, setPaymentMode] = useState(0); // 0=mpesa, 1=wallet
  const [utilize, setUtilize] = useState(0);         // 1=commission
  const [mpesaPhone, setMpesaPhone] = useState('');
  const [payText, setPayText] = useState('SEND REQUEST');
  const [resendText, setResendText] = useState('RESEND REQUEST');
  const [promptId, setPromptId] = useState(0);
  const [isMpesa, setIsMpesa] = useState(true);
  const [prompt, setPrompt] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [mpesaCode, setMpesaCode] = useState('');
  const [verifyText, setVerifyText] = useState('VERIFY');
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [checkMpesa, setCheckMpesa] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletNo, setWalletNo] = useState('');
  const [availableCommission, setAvailableCommission] = useState(0);
  const [commissionRate, setCommissionRate] = useState(0);
  const [commission, setCommission] = useState(null)
  const [basicPremium, setBasicpremium] = useState(null)

  // ── Certificate state ──
  const [isCert, setIsCert] = useState(0); // 0=pending, 1=success, 2=error
  const [certURL, setCertURL] = useState('');
  const [certErrorMessage, setCertErrorMessage] = useState('');
  const [retryText, setRetryText] = useState('RETRY');
  const [certStatus, setCertStatus] = useState('');

  // ── Proposal OID for actions ──
  const [activeProposalOID, setActiveProposalOID] = useState(null);
  const [insuredSchedule, setInsuredSchedule] = useState('');
  const [coverType, setCoverType] = useState('');
  const [policyNumber, setPolicyNumber] = useState('');
  const [commencementUnix, setCommencementUnix] = useState(null);
  const [expiryUnix, setExpiryUnix] = useState(null);
  const [DSFApproved, setDsfApproved] = useState(0);





  // ══════════════════════════════════════
  //  AUTH HEADERS
  // ══════════════════════════════════════
  const authHeaders = useCallback(() => {
    const base = { 'Content-Type': 'application/json' };
    return credentials ? { ...base, Authorization: `Basic ${credentials}` } : base;
  }, [credentials]);

  // ══════════════════════════════════════
  //  INITIAL DATA FETCHING
  // ══════════════════════════════════════

  // Credentials
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/getCredentials?username=${COMPANY}`);
        const data = await res.json();
        setCredentials(btoa(`${data.Username}:${data.Password}`));
        setIsAuth(true);
      } catch (e) {
        console.error('Credentials fetch failed', e);
        toast.error('Authentication failed');
      }
    })();
  }, []);

  // Agent from localStorage
  useEffect(() => {
    const user = localStorage.getItem('definiteagent');
    if (user) setAgent(user);
    else navigate('/login');
  }, [navigate]);

  // Agent details
  useEffect(() => {
    if (!agent || !isAuth) return;
    (async () => {
      try {
        const res = await fetch(`${API}/getDealerdetails?email=${agent}`, {
          method: 'GET', headers: authHeaders(),
        });
        const data = await res.json();
        setAgentCode(data.OID);
        setDsfApproved(data.DSFAllowed);
        setParentIntermediary(data.ParentIntermediary);
        setAgentName(data.Dealer_name || agent);
        // Fetch wallet & commission
        if (data.WalletNo) {
          setWalletNo(data.WalletNo);
          try {
            const balRes = await fetch(`${API}/getWalletbalance?wallet=${data.WalletNo}`, { headers: authHeaders() });
            const balData = await balRes.json();
            setWalletBalance(balData.Balance || 0);
          } catch { /* non-critical */ }
        }
        try {
          const commRes = await fetch(`${API}/getAvailablecommission?agent=${data.OID}`, { headers: authHeaders() });
          const commData = await commRes.json();
          setAvailableCommission(commData.AvailableCommission || 0);
        } catch { /* non-critical */ }
      } catch (e) {
        console.error('getDealerdetails error', e);
      }
    })();
  }, [agent, isAuth, authHeaders]);

  // Fetch pending proposals
  useEffect(() => {
    if (!agentCode || !isAuth) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API}/getPendingproposals?agent=${agentCode}`, {
          method: 'GET', headers: authHeaders(),
        });
        if (!res.ok) throw new Error(`API ${res.status}`);
        const data = await res.json();
        if (!cancelled) setProposals(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('Fetch proposals failed', e);
        if (!cancelled) toast.error('Failed to load pending proposals');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [agentCode, isAuth, authHeaders]);

  // ══════════════════════════════════════
  //  SEARCH & PAGINATION
  // ══════════════════════════════════════
  const filtered = useMemo(() => {
    if (!searchTerm.trim()) return proposals;
    const q = searchTerm.toLowerCase();
    return proposals.filter(
      (p) =>
        (p.Narration || '').toLowerCase().includes(q) ||
        (p.Dealer_name || '').toLowerCase().includes(q) ||
        (p.ProductDescription || '').toLowerCase().includes(q)
    );
  }, [proposals, searchTerm]);

  const totalPages = Math.ceil(filtered.length / ROWS_PER_PAGE);
  const currentRows = useMemo(
    () => filtered.slice((currentPage - 1) * ROWS_PER_PAGE, currentPage * ROWS_PER_PAGE),
    [filtered, currentPage] 
  );

    // const proposalBody = useCallback(() => ({
    //   commissionRate, agentCode, agentName, prdCode, client, commencementUnix, expiryUnix,
    //   today, coverDays, reg, productCode, payAmount, premium, basicPremium, commission,
    //   stampduty: STAMP_DUTY, PHCF, trainingLevy, netCommission, netPremium, selectedClient,
    //   makeCode, modelCode, capacity, color, tonnage, yom, coverOptioncode: coverOptionCode,
    //   sumInsured, chassis, engineNumber, cc, selectedItem, branch,
    // }), [commissionRate, agentCode, agentName, prdCode, client, commencementUnix, expiryUnix, today, coverDays, reg, productCode, payAmount, premium, basicPremium, commission, PHCF, trainingLevy, netCommission, netPremium, selectedClient, makeCode, modelCode, capacity, color, tonnage, yom, coverOptionCode, sumInsured, chassis, engineNumber, cc, selectedItem, branch]);


  const [modalLoading, setModalLoading] = useState(false);

  // ══════════════════════════════════════
  //  CERTIFICATE HELPERS
  // ══════════════════════════════════════
  const buildCertPayload = useCallback(() => ({
    IOID: insuredSchedule,
    insuredOID,
    dateDone: getNow(),
    selectedItem: itemName,
    proposalOID: activeProposalOID,
    coverType,
    clientName,
    policyNumber,
    commencementUnix,
    commencementDate,
    expiryUnix,
    expiryDate,
    reg: narration,
    chassis: chasis,
    clientPhone: clientPhone ? clientPhone.slice(1) : '',
    bodyType,
    capacity,
    makeName: make,
    modelName: model,
    engineNumber: engineNo,
    clientEmail,
    sumInsured,
    clientPin,
    yom: year,
    iraCode: '',
    tonnage,
  }), [insuredSchedule, insuredOID, itemName, activeProposalOID, coverType, clientName, policyNumber,
       commencementUnix, commencementDate, expiryUnix, expiryDate, narration, chasis, clientPhone,
       bodyType, capacity, make, model, engineNo, clientEmail, sumInsured, clientPin, year, tonnage]);

  const generateCert = useCallback(async () => {
    setCertStatus('GENERATING CERTIFICATE...');
    try {
      const res = await axios.post(CERT_WEBHOOK, buildCertPayload());
      if (res.data.success) {
        setCertURL(res.data.certURL);
        await fetch(`${API}/insertCertificate`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify({
            proposalOID: activeProposalOID, insuredOID, expiryUnix, commencementUnix,
            certNo: res.data.certNo, certLink: res.data.certURL, today: getNow(),
          }),
        });
        setIsCert(1);
      } else {
        setCertErrorMessage(res.data.errorMessage || 'Unknown error');
        await fetch(`${API}/insertCertificateerror`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify({
            proposalOID: activeProposalOID, insuredOID, expiryUnix, commencementUnix,
            errorMes: res.data.errorMessage, today: getNow(),
          }),
        });
        setIsCert(2);
      }
    } catch (e) {
      toast.error('Certificate generation failed');
      console.error(e);
      setCertStatus('');
    }
  }, [buildCertPayload, authHeaders, activeProposalOID, insuredOID, expiryUnix, commencementUnix]);

  // ══════════════════════════════════════
  //  PAYMENT HELPERS
  // ══════════════════════════════════════
  const openPayModal = () => {
    setIsCert(0); setCertURL(''); setCertStatus('');
    setPayText('SEND REQUEST'); setResendText('RESEND REQUEST');
    setPromptId(0); setPrompt(false); setIsMpesa(true);
    setShowPayModal(true);
  };

  const processPayment = async (statusSetter) => {
    const fmtPhone = '254' + mpesaPhone.slice(1);
    const ref = generateUniqueId();
    const uuid = uuidv4();
    const dateDone = getNow();
    const reg = narration;
    const payAmount = Number(grossPremium);

    if (paymentMode === 0 && utilize === 0) {
      // MPESA
      statusSetter('CHECKING PAYMENT...');
      toast.success('Prompt sent to phone!');
      setPrompt(true);
      try {
        const res = await axios.post(PAYMENT_WEBHOOK, { formattedNumber2: fmtPhone, payAmount:1, reg, uuid, qref: `QP${ref}`, dateDone }, { timeout: 30000 });
        if (res.data.success) {
          setTransactionId(res.data.transactionId);
          await fetch(`${API}/createProposal`, {
            method: 'POST', headers: authHeaders(),
            body: JSON.stringify({ utilize: 0, proposalOID: activeProposalOID, transaction: res.data.transactionId,commissionRate,agentCode,prdCode,commencementUnix,expiryUnix,today,riskClass,reg,payAmount,basicPremium,commission,stampDuty,phcf,trainingLevy,netCommission,netPremium,selectedClient,sumInsured,DSFApproved,parentIntermediary }),
            credentials: 'include',
          });

          await generateCert();
        } else {
          setPromptId(1);
          toast.error('PAYMENT NOT RECEIVED');
          statusSetter('SEND REQUEST');
        }
      } catch (e) {
        setPromptId(1);
        toast.error('PAYMENT NOT RECEIVED');
        statusSetter('SEND REQUEST');
        console.error(e);
      }
    } else if (paymentMode === 1) {
      // WALLET
      if (payAmount > walletBalance) { toast.error('INSUFFICIENT WALLET BALANCE. TOP UP TO PROCEED'); return; }
      statusSetter('CHECKING WALLET...');
      try {
        const newBal = walletBalance - payAmount;
        await axios.post(WALLET_WEBHOOK, { formattedNumber2: fmtPhone, payAmount: 1, newBalance: newBal, reg, uuid, qref: `QP${ref}`, dateDone, walletNo });
        await fetch(`${API}/createProposal`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify({ utilize: 0, proposalOID: activeProposalOID }),
          credentials: 'include',
        });
        await generateCert();
      } catch (e) { toast.error('SOMETHING WENT WRONG'); statusSetter('SEND REQUEST'); }
    } else if (utilize === 1) {
      // COMMISSION
      if (payAmount > availableCommission) { toast.error('INSUFFICIENT COMMISSION'); return; }
      statusSetter('CHECKING BALANCE...');
      try {
        await fetch(`${API}/createProposal`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify({ utilize: 1, proposalOID: activeProposalOID }),
          credentials: 'include',
        });
        await generateCert();
      } catch (e) { toast.error('SOMETHING WENT WRONG'); statusSetter('SEND REQUEST'); }
    }
  };

  const checkAutoApprovalAndPay = async () => {
    const payAmount = Number(grossPremium);
    try {
      const res = await fetch(`${API}/checkAutoApproval?proposal=${activeProposalOID}&payAmount=${payAmount}`, { headers: authHeaders() });
      const data = await res.json();
      if (data.autoApproved && data.paid) {
        setShowVerifyModal(false); setIsMpesa(false);
        toast.success('Payment received');
        await generateCert();
      } else if (!data.autoApproved && data.paid) {
        setShowVerifyModal(false);
        toast.success('Payment received');
        await fetch(`${API}/approveProposal`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify({ utilize: 0, proposalOID: activeProposalOID, transaction: transactionId }),
          credentials: 'include',
        });
        await generateCert();
      } else {
        setShowVerifyModal(true); setCheckMpesa(true);
      }
    } catch (e) { toast.error('Check failed'); console.error(e); }
  };

  const verifyMpesaCode = async () => {
    if (!mpesaCode) return;
    try {
      setVerifyText('Verifying...');
      const res = await fetch(`${API}/checkMpesa?code=${mpesaCode}&amount=${Number(grossPremium)}&reg=${narration}`, { headers: authHeaders() });
      const data = await res.json();
      if (data.success) {
        toast.success('Payment received');
        setShowVerifyModal(false);
        await fetch(`${API}/approveProposal`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify({ utilize: 0, proposalOID: activeProposalOID, transaction: mpesaCode }),
          credentials: 'include',
        });
        await generateCert();
      } else {
        toast.error('No transaction with that code');
      }
    } catch (e) { toast.error('Verification failed'); }
    finally { setVerifyText('VERIFY'); }
  };

  const retryCertificate = async () => {
    setRetryText('Please wait...');
    await generateCert();
    setRetryText('RETRY');
  };

  const openProposal = async (oid) => {
    setModalLoading(true);
    setSelectedProposal(null);
    try {
      const res = await fetch(`${API}/getThisProposal?proposal=${oid}`, {
        method: 'GET',
        headers: authHeaders(),
      });
      if (!res.ok) throw new Error(`API ${res.status}`);
      const json = await res.json();
      const {
        Pin, Email, Mobile, IRACode, ProductInsuredItem, BodyType, insuredOID,
        Client, coption, ModelName, Description, Capacity, ChasisNumber, EngineNo,
        SumInsured, Year, CC, Tonnage, ItemName, ProductDescription, Product,
        Dealer_name, ProposalNo, CommencementDate, ExpiryDate, DateDone,
        PeriodOfCover, Narration, GrossPremium, PolicyNo, GrossCommission,BasicPremium,
        PHCF, TrainingLevy, CommissionRate, BookedBy, PaidAmount,
        InsuredSchedule, CoverType, CommencementUnix, ExpiryUnix,ProductCode,RiskClass,NetCommission,NetPremium,StampDuty
      } = json;
    setActiveProposalOID(oid);
    setClientName(Dealer_name);
    setSelectedclient(Client)
    setClientEmail(Email);
    setClientPhone(Mobile); 
    setClientPin(Pin);
    setInsuredOID(insuredOID);
    setBodytype(BodyType);
    setProduct(ProductDescription);
    setCoverOption(coption);
    setMake(Description);
    setModel(ModelName);
    setCapacity(Capacity);
    setChassis(ChasisNumber);
    setYear(Year);
    setSumInsured(SumInsured);
    setEngineNo(EngineNo);
    setCC(CC);
    setTonnage(Tonnage);
    setItemName(ItemName);
    setCommencementDate(CommencementDate);
    setExpiryDate(ExpiryDate);
    setGrossPremium(GrossPremium);
    setDateDone(DateDone);
    setNarration(Narration);
    setPeriodOfCover(PeriodOfCover);
    setPolicyNo(PolicyNo);
    setPolicyNumber(PolicyNo);
    setGrossCommission(GrossCommission);
    setPHCF(PHCF);
    setTrainingLevy(TrainingLevy);
    setPaidAmount(PaidAmount);
    setInsuredSchedule(InsuredSchedule || '');
    setCoverType(CoverType || '');
    setCommencementUnix(CommencementUnix || null);
    setCommissionRate(CommissionRate);
    setExpiryUnix(ExpiryUnix || null);
    setPrdCode(ProductCode || '');
    setRiskClass(RiskClass || '');
    setNetcommission(NetCommission)
    setNetpremium(NetPremium)
    setStampduty(StampDuty)
    setCommission(GrossCommission)
    setBasicpremium(BasicPremium)

    // Reset cert state for new proposal
    setIsCert(0); setCertURL(''); setCertStatus(''); setCertErrorMessage('');
      setSelectedProposal({
        Client, Email, Mobile, Pin, insuredOID, BodyType, coption,
        Description, ModelName, Capacity, ChasisNumber, EngineNo,
        SumInsured, Year, CC, Tonnage, ItemName, ProductDescription,
        CommencementDate, ExpiryDate, DateDone, PeriodOfCover,
        Narration, GrossPremium, PolicyNo, GrossCommission, PHCF,
        TrainingLevy, CommissionRate, BookedBy, IRACode, PaidAmount,
      });
    } catch (e) {
      console.error('getThisProposal error', e);
      toast.error('Failed to load proposal details');
    } finally {
      setModalLoading(false);
    }
  }

  const closeProposal = () => {
    setSelectedProposal(null);
  }

  // Reset page when search changes
  useEffect(() => { setCurrentPage(1); }, [searchTerm]);

  // ══════════════════════════════════════
  //  RENDER
  // ══════════════════════════════════════
  return (
    <div className="pp-page">
      <Header userName={agentName || agent} />
      <Sidebar />
      <ToastContainer position="top-right" autoClose={3000} />

      <main className="pp-main">
        {/* ── Top row ── */}
        <div className="pp-top-row">
          <span className="pp-company">DEFINITE ASSURANCE</span>
          <span className="pp-breadcrumb">Proposals / Pending</span>
        </div>

        {/* ── Card ── */}
        <div className="pp-card">
          <div className="pp-card-header">
            <h3>
              <FaFileInvoice style={{ marginRight: 8, opacity: 0.7 }} />
              Pending Proposals
              <span className="pp-count">{filtered.length}</span>
            </h3>
          </div>

          {/* ── Toolbar ── */}
          <div className="pp-toolbar">
            <div className="pp-search-box">
              <FaSearch className="pp-search-icon" />
              <input
                type="text"
                placeholder="Search by registration, client or product…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* ── Table ── */}
          {loading ? (
            <div className="pp-loading">
              <FaSpinner className="pp-spinner" />
              <span>Loading pending proposals…</span>
            </div>
          ) : filtered.length === 0 ? (
            <div className="pp-empty">
              {searchTerm ? 'No proposals match your search.' : 'No pending proposals found.'}
            </div>
          ) : (
            <>
              <div className="pp-table-wrap">
                <table className="pp-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Registration</th>
                      <th>Client</th>
                      <th>Product</th>
                      <th className="pp-right">Gross Premium (KES)</th>
                      <th>Date Done</th>
                       <th>Paid Amount</th>
                      <th>Commencement</th>
                      <th>Expiry</th>
                       <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRows.map((p, i) => (
                      <tr key={p.OID || i}>
                        <td>{(currentPage - 1) * ROWS_PER_PAGE + i + 1}</td>
                        <td className="pp-reg">{p.Narration || '--'}</td>
                        <td>{p.Dealer_name || '--'}</td>
                        <td>{p.ProductDescription || '--'}</td>
                        <td className="pp-right">{formatter(p.GrossPremium)}</td>
                        <td>{formatISODate(p.DateDone)}</td>
                        <td className="pp-right">{formatter(p.PaidAmount)}</td>
                        <td>{formatISODate(p.CommencementDate)}</td>
                        <td>{formatISODate(p.ExpiryDate)}</td>
                        <td>
                            <button className="ap-extend-btn" disabled={modalLoading} onClick={() => openProposal(p.OID)}>
                              {modalLoading ? <FaSpinner className="pp-spinner" style={{ marginRight: 4 }} /> : <FaExpandArrowsAlt style={{ marginRight: 4 }} />}
                              Open Proposal
                            </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* ── Pagination ── */}
              {totalPages > 1 && (
                <div className="pp-pagination">
                  <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>‹ Prev</button>
                  {buildPageNumbers(currentPage, totalPages).map((pg, i) =>
                    pg === '...' ? (
                      <span key={`e${i}`} className="pp-ellipsis">…</span>
                    ) : (
                      <button key={pg} className={pg === currentPage ? 'active' : ''} onClick={() => setCurrentPage(pg)}>
                        {pg}
                      </button>
                    )
                  )}
                  <button disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>Next ›</button>
                </div>
              )}
            </>
          )}
        </div>

        {/* ── Modal loading overlay ── */}
        {modalLoading && (
          <div className="pp-modal-overlay">
            <div className="pp-modal-loading-box">
              <FaSpinner className="pp-spinner" style={{ fontSize: '1.8rem', color: '#1a5c5a' }} />
              <span>Loading proposal…</span>
            </div>
          </div>
        )}

        {/* ── Proposal Detail Modal ── */}
        {selectedProposal && (
          <div className="pp-modal-overlay" onClick={closeProposal}>
            <div className="pp-modal" onClick={e => e.stopPropagation()}>
              <div className="pp-modal-header">
                <h2><FaFileInvoice style={{ marginRight: 8 }} />Proposal Details</h2>
                <button className="pp-modal-close" onClick={closeProposal}>&times;</button>
              </div>
              <div className="pp-modal-body">

                <div className="pp-modal-section-title">Client Information</div>
                <div className="pp-modal-grid">
                  <div className="pp-modal-field"><span className="pp-label">Client Name</span><span className="pp-value">{clientName || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Email</span><span className="pp-value">{clientEmail || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Phone</span><span className="pp-value">{clientPhone || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">PIN / ID</span><span className="pp-value">{clientPin || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">IRA Code</span><span className="pp-value">{selectedProposal.IRACode || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Booked By</span><span className="pp-value">{selectedProposal.BookedBy || '--'}</span></div>
                </div>

                <div className="pp-modal-section-title">Vehicle / Item</div>
                <div className="pp-modal-grid">
                  <div className="pp-modal-field"><span className="pp-label">Registration / Narration</span><span className="pp-value pp-bold">{narration || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Item Name</span><span className="pp-value">{itemName || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Make</span><span className="pp-value">{make || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Model</span><span className="pp-value">{model || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Body Type</span><span className="pp-value">{bodyType || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Year</span><span className="pp-value">{year || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Capacity (cc)</span><span className="pp-value">{capacity || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Engine CC</span><span className="pp-value">{cc || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Engine No.</span><span className="pp-value">{engineNo || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Chasis No.</span><span className="pp-value">{chasis || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Tonnage</span><span className="pp-value">{tonnage || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Sum Insured (KES)</span><span className="pp-value pp-bold">{formatter(sumInsured)}</span></div>
                </div>

                <div className="pp-modal-section-title">Cover Details</div>
                <div className="pp-modal-grid">
                  <div className="pp-modal-field"><span className="pp-label">Product</span><span className="pp-value">{product || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Cover Option</span><span className="pp-value">{coption || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Policy No.</span><span className="pp-value">{policyNo || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Period of Cover</span><span className="pp-value">{periodOfCover || '--'}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Commencement</span><span className="pp-value">{formatISODate(commencementDate)}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Expiry</span><span className="pp-value">{formatISODate(expiryDate)}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Date Done</span><span className="pp-value">{formatISODate(dateDone)}</span></div>
                </div>

                <div className="pp-modal-section-title">Financials</div>
                <div className="pp-modal-grid">
                  <div className="pp-modal-field"><span className="pp-label">Gross Premium (KES)</span><span className="pp-value pp-bold pp-green">{formatter(grossPremium)}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Paid Amount (KES)</span><span className="pp-value pp-bold">{formatter(paidAmount)}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Gross Commission (KES)</span><span className="pp-value">{formatter(grossCommission)}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Commission Rate</span><span className="pp-value">{selectedProposal.CommissionRate || '--'}%</span></div>
                  <div className="pp-modal-field"><span className="pp-label">PHCF</span><span className="pp-value">{formatter(phcf)}</span></div>
                  <div className="pp-modal-field"><span className="pp-label">Training Levy</span><span className="pp-value">{formatter(trainingLevy)}</span></div>
                </div>

              </div>
              <div className="pp-modal-footer">
                {/* Action buttons based on payment status */}
                {Number(paidAmount) === 0 && (
                  <button className="pp-btn-action pp-btn-pay" onClick={() => { closeProposal(); openPayModal(); }}>
                    <FaCreditCard style={{ marginRight: 6 }} /> Pay &amp; Generate Certificate
                  </button>
                )}
                {Number(paidAmount) > 0 && Number(paidAmount) >= Number(grossPremium) && (
                  <button className="pp-btn-action pp-btn-cert" onClick={() => { closeProposal(); setShowPayModal(true); setIsCert(0); setCertURL(''); setCertStatus(''); }}>
                    <FaCertificate style={{ marginRight: 6 }} /> Generate Certificate
                  </button>
                )}
                <button className="pp-btn-close" onClick={closeProposal}>Close</button>
              </div>
            </div>
          </div>
        )}

        {/* ══════════════════════════════════════
            PAYMENT / CERTIFICATE MODAL
           ══════════════════════════════════════ */}
        {showPayModal && (
          <div className="pp-modal-overlay">
            <div className="pp-modal pp-modal-sm" onClick={e => e.stopPropagation()}>
              <div className="pp-modal-header">
                <h2>{isCert === 0 ? (Number(paidAmount) >= Number(grossPremium) ? 'Generate Certificate' : 'Make Payment') : isCert === 1 ? 'Certificate Ready' : 'Certificate Error'}</h2>
                {isCert === 0 && (
                  <button className="pp-modal-close" onClick={() => { setShowPayModal(false); setIsCert(0); setPrompt(false); setPayText('SEND REQUEST'); }}>&times;</button>
                )}
              </div>
              <div className="pp-modal-body">
                {isCert === 0 && (
                  <>
                    {/* Only show payment inputs when not fully paid */}
                    {Number(paidAmount) < Number(grossPremium) && (
                      <>
                        <div className="pp-pay-amount">
                          <p>Amount to Pay</p>
                          <h4>KES. {formatter(grossPremium)}</h4>
                          <span className="pp-reg-tag">{narration}</span>
                        </div>

                        {/* Payment mode tabs */}
                        <div className="pp-pay-tabs">
                          {/* <button className={`pp-pay-tab ${paymentMode === 0 && utilize === 0 ? 'active' : ''}`} onClick={() => { setPaymentMode(0); setUtilize(0); setIsMpesa(true); }}>M-Pesa</button> */}
                          {/* <button className={`pp-pay-tab ${paymentMode === 1 ? 'active' : ''}`} onClick={() => { setPaymentMode(1); setUtilize(0); setIsMpesa(false); }}>Wallet</button>
                          <button className={`pp-pay-tab ${utilize === 1 ? 'active' : ''}`} onClick={() => { setPaymentMode(0); setUtilize(1); setIsMpesa(false); }}>Commission</button> */}
                        </div>

                        {isMpesa && (
                          <div className="pp-form-group">
                            <label>M-Pesa Number *</label>
                            <input type="text" value={mpesaPhone} onChange={e => setMpesaPhone(e.target.value)} placeholder="e.g. 0712345678" />
                          </div>
                        )}
                        {paymentMode === 1 && (
                          <p className="pp-balance-note">Wallet Balance: <strong>KES. {formatter(walletBalance)}</strong></p>
                        )}
                        {utilize === 1 && (
                          <p className="pp-balance-note">Available Commission: <strong>KES. {formatter(availableCommission)}</strong></p>
                        )}

                        {promptId === 0 && (
                          <button className="pp-btn-action pp-btn-pay" style={{ width: '100%', marginBottom: 10 }}
                            onClick={() => processPayment(setPayText)}
                            disabled={payText !== 'SEND REQUEST'}>
                            {payText !== 'SEND REQUEST' ? <FaSpinner className="pp-spinner" style={{ marginRight: 6 }} /> : null}
                            {payText}
                          </button>
                        )}
                        {promptId === 1 && (
                          <button className="pp-btn-action pp-btn-pay" style={{ width: '100%', marginBottom: 10 }}
                            onClick={() => processPayment(setResendText)}
                            disabled={resendText !== 'RESEND REQUEST'}>
                            {resendText}
                          </button>
                        )}

                        {isMpesa && !prompt && (
                          <>
                            <div className="pp-separator">─── OR ───</div>
                            <div className="pp-mpesa-steps">
                              <p>1. Go to M-Pesa Toolkit → Lipa na M-Pesa → Paybill</p>
                              <p>2. Paybill Number: <strong>200300</strong></p>
                              <p>3. Account: <strong>{narration}</strong></p>
                              <p>4. Amount: <strong>KES. {formatter(grossPremium)}</strong></p>
                              <p>5. Complete with M-Pesa PIN</p>
                              <button className="pp-already-paid" onClick={checkAutoApprovalAndPay}>Already paid? Click here</button>
                            </div>
                          </>
                        )}
                      </>
                    )}

                    {/* Fully paid — just generate cert */}
                    {Number(paidAmount) >= Number(grossPremium) && (
                      <>
                        <p className="pp-paid-note">✅ Payment of <strong>KES. {formatter(paidAmount)}</strong> confirmed for <strong>{narration}</strong>.</p>
                        {certStatus && <p className="pp-cert-status">{certStatus}</p>}
                        <button className="pp-btn-action pp-btn-cert" style={{ width: '100%' }} onClick={generateCert} disabled={!!certStatus}>
                          {certStatus ? <FaSpinner className="pp-spinner" style={{ marginRight: 6 }} /> : <FaCertificate style={{ marginRight: 6 }} />}
                          {certStatus || 'Generate Certificate'}
                        </button>
                      </>
                    )}
                  </>
                )}

                {isCert === 1 && (
                  <div className="pp-cert-success">
                    <FaCertificate style={{ fontSize: '2.5rem', color: '#27ae60', marginBottom: 12 }} />
                    <p>Certificate generated successfully!</p>
                    <a href={certURL} target="_blank" rel="noreferrer" className="pp-cert-download">DOWNLOAD CERTIFICATE</a>
                    <button className="pp-btn-close" style={{ marginTop: 16 }} onClick={() => { setShowPayModal(false); window.location.reload(); }}>FINISH</button>
                  </div>
                )}

                {isCert === 2 && (
                  <div className="pp-cert-error">
                    <p>⚠️ Error: {certErrorMessage}</p>
                    <button className="pp-btn-action pp-btn-pay" onClick={retryCertificate} disabled={retryText !== 'RETRY'}>{retryText}</button>
                    <button className="pp-btn-close" style={{ marginTop: 10 }} onClick={() => setShowPayModal(false)}>Close</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ══════════════════════════════════════
            VERIFY MPESA MODAL
           ══════════════════════════════════════ */}
        {showVerifyModal && (
          <div className="pp-modal-overlay">
            <div className="pp-modal pp-modal-sm" onClick={e => e.stopPropagation()}>
              <div className="pp-modal-header">
                <h2>Confirm Payment</h2>
                <button className="pp-modal-close" onClick={() => { setShowVerifyModal(false); setCheckMpesa(false); }}>&times;</button>
              </div>
              <div className="pp-modal-body">
                {!checkMpesa && <p style={{ textAlign: 'center' }}>Checking payment, please wait…</p>}
                {checkMpesa && (
                  <>
                    <p style={{ color: '#c0392b', marginBottom: 12 }}>Enter the M-Pesa transaction code below</p>
                    <div className="pp-form-group">
                      <label>Transaction Code</label>
                      <input type="text" value={mpesaCode} onChange={e => setMpesaCode(e.target.value)} placeholder="e.g. SBK1234ABC" />
                    </div>
                    <button className="pp-btn-action pp-btn-pay" style={{ width: '100%' }} onClick={verifyMpesaCode} disabled={verifyText !== 'VERIFY'}>
                      {verifyText}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

      </main>
    </div>
  );
}
